// hooks/useDaumPostcode.js
import { useEffect, useRef, useState } from 'react';

export default function useDaumPostcode(onCompleteCallback) {
  const [isOpen, setIsOpen] = useState(false);
  const popupRef = useRef(null);

  const handleComplete = (data) => {
    let fullAddress = data.address;
    console.log("address :: ",fullAddress);
    if (data.addressType === 'R') {
      if (data.bname) fullAddress += ` (${data.bname})`;
      if (data.buildingName) fullAddress += `, ${data.buildingName}`;
    }
    onCompleteCallback(fullAddress);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return { isOpen, setIsOpen, handleComplete, popupRef };
}
